module.exports = __webpack_public_path__ + "img/bg_slutskærm_mobile.68326cce.svg";